// Full-document render of the toppers generic FormPage: the UtilityPage shell
// (PageSkeleton + side nav + ContentTitle + right bar) with the rich-text intro
// and the Wagtail form-builder form in content__copy. The form fields are
// rendered natively in React from the per-field FormFieldData serialization (the
// form is built dynamically from CMS form_fields, so reactivated's FormType
// can't serialize it).
import React from "react";
import { FormPageFields } from "tsi-common-react/src/forms/FormPageFields/index";
import { t } from "ttag";

import { templates } from "@reactivated";

import { CSRFToken } from "@reactivated/forms";

import { RightBarSection } from "../blocks/RightBarSection";
import { ContentTitle } from "../components/ContentTitle";
import { PageSkeleton } from "../components/PageSkeleton";
import { UtilitySideNav } from "../components/UtilitySideNav";

export const Template = (
    props: templates.FormPageTemplate,
): React.JSX.Element => {
    const {
        nav_items,
        has_right_bar,
        right_bar_items,
        content_title,
        content_title_phone_href,
        content_title_phone_display,
        intro_html,
        action_url,
        fields,
    } = props;
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <div className="l-capped-width u-margin-bottom--xl u-full-width-title">
                {nav_items.length > 0 && (
                    <div className="l-side-nav">
                        <UtilitySideNav items={nav_items} />
                    </div>
                )}

                <div className="l-side-nav-content">
                    <ContentTitle
                        title={content_title}
                        phoneHref={content_title_phone_href}
                        phoneDisplay={content_title_phone_display}
                    />

                    <div
                        className={
                            has_right_bar
                                ? "content__copy"
                                : "content__copy--full-width"
                        }
                    >
                        {/* form_page.html's {% block extra_body %} wraps the
                            intro + form in a bare <div>. */}
                        <div>
                            <div
                                className="rich-text"
                                dangerouslySetInnerHTML={{ __html: intro_html }}
                            />
                            <form action={action_url} method="POST">
                                <CSRFToken />
                                <FormPageFields fields={fields} />
                                <input type="submit" aria-label={t`Submit`} />
                            </form>
                        </div>
                    </div>

                    {has_right_bar && (
                        <aside className="content__aside">
                            {right_bar_items.map((item, i) =>
                                item.block_type === "right_bar_section" &&
                                item.section ? (
                                    <div
                                        key={i}
                                        className={`w-block-${item.block_type} block-${item.block_type}`}
                                    >
                                        <RightBarSection value={item.section} />
                                    </div>
                                ) : (
                                    <div
                                        key={i}
                                        className={`w-block-${item.block_type} block-${item.block_type}`}
                                        dangerouslySetInnerHTML={{
                                            __html: item.html,
                                        }}
                                    />
                                ),
                            )}
                        </aside>
                    )}
                </div>
            </div>
        </PageSkeleton>
    );
};
